var _rect, _path, _path2, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJsp = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 36,
  x: 9,
  y: 2,
  fill: "#EBEBEB",
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C8C8C8",
  d: "M9 29h30v7a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDD",
  d: "M30 29V2h7a2 2 0 0 1 2 2v25z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 19.5,
  x: 1,
  y: 11,
  fill: "#303030",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6.49 22.45q.04.33.12.6.09.26.25.45.17.18.42.29.26.1.64.1.73 0 1.04-.42t.31-1.2v-4.66h1.21v4.74q0 1.28-.69 1.93-.68.65-1.85.65-1.23 0-1.9-.6t-.76-1.88zm6.232.12q.08.7.5 1.02.43.32 1.27.32.41 0 .69-.09t.45-.24a.8.8 0 0 0 .24-.35q.07-.21.07-.44 0-.17-.05-.33a.8.8 0 0 0-.18-.31 1.1 1.1 0 0 0-.35-.24 2 2 0 0 0-.56-.17l-.91-.17a6 6 0 0 1-.96-.25q-.42-.15-.71-.39a1.7 1.7 0 0 1-.43-.6 2.4 2.4 0 0 1-.14-.87q0-.51.2-.89.21-.38.57-.63.36-.26.85-.38a4.3 4.3 0 0 1 1.08-.13q.74 0 1.24.17t.81.45q.31.27.47.63t.22.75l-1.14.18q-.14-.6-.49-.89-.34-.29-1.09-.29-.43 0-.72.08-.28.07-.46.21a.8.8 0 0 0-.25.31.9.9 0 0 0-.07.36q0 .47.25.7.26.23.9.36l.99.19q1.13.21 1.66.72.53.5.53 1.45 0 .45-.17.84a1.8 1.8 0 0 1-.5.67 2.5 2.5 0 0 1-.85.44 3.6 3.6 0 0 1-1.17.17q-1.37 0-2.15-.57-.78-.58-.86-1.79zm5.645-4.96h2.47q.81 0 1.33.18.53.18.83.48t.42.7q.12.39.12.82 0 .46-.12.88t-.43.74q-.3.31-.82.5-.52.18-1.31.18h-1.3v2.66h-1.19zm2.46 3.47q.46 0 .75-.09.3-.09.47-.25a.87.87 0 0 0 .23-.4q.07-.23.07-.52 0-.3-.07-.52a.8.8 0 0 0-.25-.38q-.17-.15-.47-.23a2.9 2.9 0 0 0-.74-.08h-1.26v2.47z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgJsp);
export default ForwardRef;